module.exports = __webpack_public_path__ + "static/media/date-chess.65a66747.png";